/**
 * Page Transition Constants
 *
 * Defines transition types, directions, and timing constants for page-to-page
 * transitions in multi-page designs.
 */

/**
 * All available page transition types
 */
export const PAGE_TRANSITION_TYPES = [
  "none",
  "slide",
  "fade",
  "slide-over",
  "wipe"
];

/**
 * Transition types that require a direction parameter
 */
export const PAGE_TRANSITION_DIRECTIONAL_TYPES = [
  "slide",
  "slide-over",
  "wipe"
];

/**
 * Valid directions for directional transitions
 */
export const PAGE_TRANSITION_DIRECTIONS = ["left", "right", "up", "down"];

/**
 * Default direction for directional transitions
 */
export const PAGE_TRANSITION_DEFAULT_DIRECTION = "left";

/**
 * Minimum transition duration in milliseconds
 */
export const PAGE_TRANSITION_MIN_DURATION = 250;

/**
 * Maximum transition duration in milliseconds
 */
export const PAGE_TRANSITION_MAX_DURATION = 4000;

/**
 * Default transition duration in milliseconds
 */
export const PAGE_TRANSITION_DEFAULT_DURATION = 500;

/**
 * Default transition type
 */
export const PAGE_TRANSITION_DEFAULT_TYPE = "none";
